import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/imgs/opBtn.png'


const _withScopeId = n => (_pushScopeId("data-v-cf079a76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "openbool-wrapper" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-end"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"14px","height":"14px","margin-right":"6px"},
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 操作手册")
const _hoisted_5 = { class: "book-wrapper" }
const _hoisted_6 = { style: {"margin-left":"10px"} }
const _hoisted_7 = { class: "books" }
const _hoisted_8 = { class: "tool-tips" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "user-table-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600","font-size":"14px","color":"#333333","margin-top":"97px"} }, "为方便您更快捷地完成流程，请查看系统操作手册", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 查看手册")

import { ref, reactive } from "vue";
import Title from "@/components/Title.vue";
import HeadTitle from "@/components/HeadTitle.vue";
import { Card, Tooltip } from "ant-design-vue";
import { USERLIST, BOOKLIST } from "../const/home";
import { previewFile } from "@/api/index";
import { staffGetStaffConfig } from "@/api/api";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pageSize = ref<number>(5);
const pagination = reactive({
  defaultPageSize: pageSize.value,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: ["5", "10", "20", "30", "40"],
  showTotal: (total: number) => `共 ${total} 条数据`,
  showSizeChange: (current: number, size: number) => {
    pageSize.value = size;
  },
});

const handleClick = async (title: string) => {
  // window.open(title);
  const Data = await previewFile(title || "");
  if (Data) {
    window.open(Data);
  }
};

const tableData = [
  {
    depart: "人力发展中心",
    name: "李慧",
    duty: "开设系统账号审批、员工调动审批",
    email: "lihui1@risfond.com",
    phone: "18612393319",
  },
  {
    depart: "风控合规中心",
    name: "郑晓雪",
    duty: "房屋租赁合同审批、工商注册及备案审批",
    email: "xiaoxue.zheng@risfond.com",
    phone: "13911699671",
  },
  // {
  //   depart: "综合管理中心",
  //   name: "张思然",
  //   duty: "公司选址及装修咨询",
  //   email: "siran.zhang@risfond.com",
  //   phone: "13521222804",
  // },
  {
    depart: "财务管理中心",
    name: "张馨予",
    duty: "财务支持全模",
    email: "Zhangxinyu@risfond.com",
    phone: "15010170908",
  },
  {
    depart: "财务管理中心",
    name: "宋宁",
    duty: "账套审批",
    email: "sunny.sn@risfond.com ",
    phone: "19801196330",
  },
  {
    depart: "财务管理中心",
    name: "张小光",
    duty: "银行开户",
    email: "eden.zhang@risfond.com ",
    phone: "13671096650",
  },
  // {
  //   depart: "总经办",
  //   name: "纪银红",
  //   duty: "全流程咨询",
  //   email: "Jan.Ji@risfond.com",
  //   phone: "18810273871",
  // },
  {
    depart: "客户运营中心",
    name: "赵振兴",
    duty: "客户及人选交接问题",
    email: "ash.zhao@risfond.com",
    phone: "13810621126",
  },
  // {
  //   depart: "市场品牌中心",
  //   name: "李诗婷",
  //   duty: "开业推广",
  //   email: "Amelia.lis@Risfond.com",
  //   phone: "15940514557",
  // },
  {
    depart: "市场品牌中心",
    name: "孟静",
    duty: "开业推广",
    email: "Jean.meng@risfond.com",
    phone: "18301629536",
  },
  {
    depart: "科技智能研发中心",
    name: "乔相坤",
    duty: "打卡机设置、摄像头安装、电视安装",
    email: "qiaoxiangkun@risfond.com",
    phone: "18801346219",
  },
];
const modalShow = ref<boolean>(false);
const checkModalShow = () => {
  //Data =1 是首次进入 0 不是
  staffGetStaffConfig().then((res) => {
    if (res.Data === 1) {
      modalShow.value = true;
    }
  });
};
checkModalShow();
const clickBook = () => {
  openBook();
};
const openBook = () => {
  modalShow.value = false;
  if (
    process.env.NODE_ENV == "development" ||
    process.env.VUE_APP_BUILD == "test"
  ) {
    window.open("http://pre.risfond.com/staff/help");
  } else {
    window.open("https://staff-help.risfond.com/web/#/2/319");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Title, { title: "开业管理" }),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "opBtn",
          onClick: clickBook,
          size: "small"
        }, {
          icon: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(HeadTitle, { title: "各部门开业流程说明手册" })
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BOOKLIST), (item, index) => {
            return (_openBlock(), _createBlock(_unref(Tooltip), {
              placement: "bottom",
              class: "book",
              key: index,
              overlayClassName: "tool-tips-wrapper"
            }, {
              title: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(Card), {
                  hoverable: "",
                  class: "book-card",
                  onClick: ($event: any) => (handleClick(item.title)),
                  style: _normalizeStyle({ backgroundImage: `url(${item.bg})` })
                }, {
                  cover: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "book-img",
                      src: item.img
                    }, null, 8, _hoisted_9)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(Card).Meta, {
                      title: item.title
                    }, null, 8, ["title"])
                  ]),
                  _: 2
                }, 1032, ["onClick", "style"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(HeadTitle, { title: "各模块对接成员名单" }),
        _createVNode(_component_a_table, {
          class: "user-table",
          dataSource: tableData,
          columns: _unref(USERLIST),
          pagination: false
        }, null, 8, ["columns"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: modalShow.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((modalShow).value = $event)),
      title: null,
      width: "388px",
      footer: null,
      centered: "",
      class: "modalClass"
    }, {
      default: _withCtx(() => [
        _hoisted_11,
        _createVNode(_component_a_button, {
          class: "bookBtn",
          type: "primary",
          onClick: openBook
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})